import { I18n } from '@/i18n/I18n';
import { load, dump } from 'js-yaml';

export function parseTaskKeys(tasksString: string): string {
  let tasks: any[];
  try {
    tasks = load(tasksString, {}) as any[];
  } catch {
    throw new Error(I18n.get('invalidYaml'));
  }
  if (typeof tasks !== 'object' && !Array.isArray(tasks)) {
    throw new Error(I18n.get('invalidTaskShape'));
  }
  if (typeof tasks === 'object' && !Array.isArray(tasks)) {
    tasks = [tasks];
  }

  for (let index = 0; index < tasks.length; index += 1) {
    const task = tasks[index];
    if (typeof task !== 'object') {
      throw new Error(I18n.get('invalidIndividualTask'));
    }
    const taskKeys = Object.keys(task);
    if (taskKeys.length !== 1) {
      throw new Error(I18n.get('invalidNumberOfTaskKeys'));
    }
    const taskKey = taskKeys[0];
    const paramsCopy: any = {};
    Object.assign(paramsCopy, tasks[index][taskKey]);

    const splitKey = taskKey.split('.');
    if (splitKey.length !== 2 || taskKey.includes(' ')) {
      throw new Error(I18n.get('invalidTaskKey'));
    }
    Object.values(task).forEach(taskValue => {
      if (typeof taskValue !== 'object') {
        throw new Error(I18n.get('invalidTaskArgument'));
      }
    });
  }

  let parsedTasks: string;
  try {
    parsedTasks = dump(tasks, { lineWidth: -1 });
  } catch {
    throw new Error(I18n.get('invalidYaml'));
  }

  if (parsedTasks.includes('\'[object Object]\': null')) {
    throw new Error(I18n.get('invalidObjectInTaskArg'));
  }

  return parsedTasks;
}